import * as z from "zod";

export const deleteSegment = {
  name: "deleteSegment" as const,
  input: z.string(),
  output: z.null(),
};
